export enum Feature {
  Coaching = 'coaching',
  Learn = 'learn',
  Insights = 'insights',
  CreateOrganization = 'new-organizations',
  Changelog = 'changelog',
  Goals = 'goals',
  PromoCodeApply = 'promo-code-apply'
}
